// extracted by mini-css-extract-plugin
export default {"content":"create-gift-card_content__yHLJQ","giftCardContainer":"create-gift-card_giftCardContainer__bvohP","block":"create-gift-card_block__CnO9U"};